import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'

import Input from '../ui/Input';
import Button from '../ui/Button';
import {showForms} from '../../store/action/animationForm'
import { checkPhone, fetchOTP, checkOTP } from '../../store/action/authorization';
import { repeatInc } from './statusForms/image';
class SignIn extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      phoneNumber: '+380',
      submitCode: false, // false
      code: {
        0: '',
        1: '',
        2: '',
        3: ''
      },
      changeNumberInput: 0,
      errorValid: false,
      codeText: '',
      errorOTP: false,
      countOTPSend: 0,
      maxCountOTPSend: 5,
      countFetchOtp: 0,
      blockedFetchOtp: false,
      fetchOTP: false,
      blockedUser: false
    }
    this.formRef = React.createRef()
    this.focusCode = React.createRef()
    this.arrRefInput = [
      this.textInput1 = React.createRef(),
      this.textInput2 = React.createRef(),
      this.textInput3 = React.createRef(),
      this.textInput4 = React.createRef(),
    ]
  }

  componentDidMount(){
    const {phone} = this.props.match.params
    const url = new URL(window.location.href).searchParams
    const token = url.get('credit_card_token')
    if(phone){
      this.props.onCheckPhone(phone[0] === '+' ? phone : `+${phone}`, token )
    }
  }

  onChange = e => {
    const name = e.target.name
    let value = e.target.value
    const reg = new RegExp(/^\+380\d{0,9}$/)
    const defaultParams = {
      submitCode: false,
      countOTPSend: 0,
      countFetchOtp: 0,
      blockedUser: false,
      errorOTP: false,
      blockedFetchOtp: false,
      errorValid: false,
      codeText: ''
    }
    if(reg.test(value) && value.length <= 13){
      const checkPlus = value.indexOf('+') !== -1 ? value.replace('+','') : value
      this.setState({[name]: '+'+checkPlus, ...defaultParams})
    } else if(value === '' || value === '+')
      this.setState({[name]: '+380', ...defaultParams})
  }
  onResetNumber = () => {
    this.setState({
      phoneNumber: '+380',
      submitCode: false,
      countOTPSend: 0,
      countFetchOtp: 0,
      blockedUser: false,
      errorOTP: false,
      blockedFetchOtp: false,
      errorValid: false,
      codeText: ''
    })
    clearTimeout(this.timerOtp)
    clearTimeout(this.timerOtpCode)
    this.textInputPhone.focus()
  }
  onChangeCode = e => {
    const reg = new RegExp(/^\d+$/)
    if(reg.test(e.target.value) && e.target.value.length < 2 ){
      let numberInput = e.target.id 
      if(e.target.value !== ''){
        numberInput = +e.target.id === 3 ? 3 : +e.target.id + 1
      }
      this.setState({
        changeNumberInput: numberInput,
        code: {...this.state.code, [e.target.id]: e.target.value}
      }, () => {
        const {changeNumberInput} = this.state
          if(this.arrRefInput[changeNumberInput].current){
            this.arrRefInput[changeNumberInput].current.focus()
          }
      })
    } else if(e.target.value.length === 0){
      this.setState({
        code: {...this.state.code, [e.target.id]: e.target.value}
      })
    }

  }
  onResetCode = () => {
    this.setState({codeText: ''})
    this.focusCode.current && this.focusCode.current.focus()
  }
  checkShowButtonDelete = () => 
    Object.keys(this.state.code)
    .some(item => this.state.code[item] !== '')
  renderInputCodeElement = () => (
    [1,2,3,4].map(item => (
      <input
        key={item}
        type="number"
        autoFocus={item === 1}
        value={this.state.code[item - 1]}
        className="otp-input"
        id={`${item - 1}`}
        ref={this[`textInput${item}`]}
        maxLength={1}
        onChange={this.onChangeCode}
        />
    ))
  )
  renderFormOtp = () => {
    return (
      <div className="form-otp">
        <span className="title">Введіть код з CMC</span>
        <div className="container-otp-inputs">
          <input
            type='tel'
            pattern="\d*"
            className='code'
            value={this.state.codeText}
            onChange={this.onChangeCodeText}
            ref={this.focusCode}
            autoFocus={true}
          />
          {this.state.codeText.length !== 0 &&
            <button type='button' className="reset-password" onClick={this.onResetCode}/>
          }
          <span className='error-otp'>{this.checkTypeErrorOTP()}</span>
        </div>
        <button type='button' className="retry-button" onClick={this.onFetchOtp}>
          {repeatInc}
          <span className="retry-button_test">Відправити код повторно</span>
        </button>
      </div>
    )
  }
  onFetchOtp = () => {
    const {countFetchOtp} = this.state
    if(countFetchOtp < 2){
      this.props.onFetchOTP(this.state.phoneNumber).then(res => {
        if(res === 'blockedUser')
          this.setState({blockedUser: true})
        else
          this.setState({blockedUser: false, countFetchOtp: countFetchOtp + 1})
      })
      this.onResetCode()
      this.timerOtpp()
    } else {
      this.setState({blockedFetchOtp: true})
    }
  }
  checkTypeErrorOTP = () => {
    const {errorOTP, countOTPSend, maxCountOTPSend, blockedFetchOtp, codeText, errorValid} = this.state
    if(errorOTP && countOTPSend <= maxCountOTPSend)
      return 'Невірний код із СМС'
    else if(blockedFetchOtp)
      return 'Перевищено кількість запитів коду, зачекайте 5 хв'
    else if(errorOTP && countOTPSend > maxCountOTPSend)
      return 'Перевірте номер або отримайте новий код'
    else if(errorValid && codeText.length !== 4)
      return 'Пароль має складатися з 4-х цифр'
    return ''
  }
  onSubmit = e => {
    e.preventDefault()
    const {phoneNumber, codeText, countFetchOtp} = this.state
    if(phoneNumber.length === 13 && !this.state.submitCode && !this.state.fetchOTP){
      if(countFetchOtp <= 1){
        this.setState({fetchOTP: true})
        this.props.onFetchOTP(phoneNumber).then(res => {
          if(res && res.status && res.status === 200)
            this.setState({submitCode: true, fetchOTP: false, blockedUser: false, countFetchOtp: countFetchOtp + 1})
          else if(res === 'blockedUser')
            this.setState({blockedUser: true, fetchOTP: false})
        })
      }
    } else if(phoneNumber.length === 13 && this.state.submitCode && codeText.length === 4){
      const {countOTPSend, maxCountOTPSend} = this.state
      this.setState({countOTPSend: countOTPSend + 1})
      if(countOTPSend + 1 <= maxCountOTPSend){
        if(countOTPSend + 1 === maxCountOTPSend)
          this.setTimerOTPCode()
        this.props.onCheckOTP(phoneNumber, codeText).then(res => {
          if(res === 'errorOTP')
            this.setState({errorOTP: true})
        })    
      }
    } else
      this.setState({errorValid: true})
  }
  timerOtpp = () => {
      this.timerOtp = setTimeout(() => {
        this.setState({countFetchOtp: 0, blockedFetchOtp: false})
      }, 300000)
  }
  setTimerOTPCode = () => {
    this.timerOtpCode = setTimeout(() => {
      this.setState({countOTPSend: 0, errorOTP: false})
    }, 300000)
  }
  setRef = (input) => {
    this.textInputPhone = input;
  }
  validNumber = () => {
    const {phoneNumber} = this.state
    if(phoneNumber.length < 13)
      return 'Невірний формат номеру'
    return false
  }
  onChangeCodeText = e => {
    if(/^\d{0,4}$/.test(e.target.value))
      this.setState({
        codeText: e.target.value.replace(/^\s$/g, '')
      })
  }
  checkDisableButton = () => {
    const {submitCode, phoneNumber, codeText} = this.state
    if(!submitCode)
      return phoneNumber.length === 13 ? 'success' : 'disable'
    return  codeText.length === 4 ? 'success' : 'disable'
  }
  render(){
    const {phoneNumber, submitCode, blockedUser, errorValid} = this.state
    return (
      <form className="signIn-form" onSubmit={this.onSubmit} >
        <div className="scroll-container">
          <div className="signin-container">
            <div className="info-container" >
              <div className="input-form-container">
                <Input
                  name='phoneNumber'
                  value={phoneNumber}
                  onChange={this.onChange}
                  onResetNumber={this.onResetNumber}
                  placeholder='+380'
                  showButtonDelete={phoneNumber.length !== 4}
                  setRef={this.setRef}
                  autoFocus={true}
                  title='Введіть ваш номер телефону'
                  type='tel'
                />
                {blockedUser && 
                  <span className='error-otp'>Перевищено кількість запитів коду, спробуйте пізніше</span>
                }
                {errorValid && phoneNumber.length < 13 && 
                  <span className='error-otp'>Невірний формат номеру телефону</span>}
              </div>
              {submitCode && this.renderFormOtp()}
            </div>
            <div className='button-container-footer'>
              <Button 
                type='submit'
                title='Далі'
                color={this.checkDisableButton()}
              />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

SignIn.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      phone: PropTypes.string
    }).isRequired,
  }).isRequired,
  onShowHorms: PropTypes.func.isRequired,
  onCheckPhone: PropTypes.func.isRequired,
  onCheckOTP: PropTypes.func.isRequired,
  onFetchOTP: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  auth: state.authorization
})

const mapDispatchToProps = dispatch => ({
    onShowHorms: () => dispatch(showForms()),
    onCheckPhone: (phone, token) => dispatch(checkPhone(phone, token)),
    onFetchOTP: phone => dispatch(fetchOTP(phone)),
    onCheckOTP: (phone, otp) => dispatch(checkOTP(phone, otp))
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignIn))